export default __webpack_public_path__ + "static/media/addProduct1.e15fd5a7.jpg";